import { isEmpty, isNull } from "lodash";
import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { anonymousRocketChat, setRocketStore, createRocketChat, setAnonymousLobby, getCookie, setOverridename } from "../../helpers";
import { SET_CONNECT_LOBBY } from "../../redux/actions/type";

const AnonymousRocket = ({ anonymouseInfo, roomName, isReady, reservationId }) => {
    const dispatch = useDispatch()
    const { name: anonymousName, id: anonymousID } = anonymouseInfo

    useEffect(() => {
        const initConn = async () => {
            if (isReady && !isNull(reservationId)) {
                try {
                    const rocketChatInfo = getCookie('rocketChatInfo') ? JSON.parse(getCookie('rocketChatInfo')) : {}

                    //check change Name
                    if (!isEmpty(rocketChatInfo) && decodeURIComponent(rocketChatInfo.name) !== decodeURIComponent(anonymousName)) {
                        await setOverridename({ overrideName: decodeURIComponent(anonymousName), chatUserID: rocketChatInfo.chatUserID }, 'AnonymousRocket')
                    }

                    //authen rocket
                    const { chatUserID, chatUserToken } = await anonymousRocketChat({ anonymousName: decodeURIComponent(anonymousName), anonymousID })

                    // createChatRoom
                    const { data: { group: { _id, name } } } = await createRocketChat({ members: [anonymousID], name: `${reservationId}_${chatUserID}` })
                    setRocketStore({ name: anonymousName, chatUserID, chatUserToken, reservationId })

                    dispatch({
                        type: SET_CONNECT_LOBBY,
                        payload: {
                            lobbyRoomID: name
                        }
                    })

                    //connect rocket chat.
                    setAnonymousLobby({ name: anonymousName, chatUserID, chatUserToken, roomName, reservationId, chatRoomId: _id, anonymousID }, dispatch)

                } catch (error) {
                    console.error('AnonymousRocketConn', error)
                }
            }
        }
        initConn()
    }, [anonymousName, anonymousID, roomName, isReady, reservationId, dispatch])

    return null
}

export default AnonymousRocket
